export function b64Encode(s: string): string {
    const utf8Bytes = new TextEncoder().encode(s)

    return btoa(String.fromCharCode(...utf8Bytes))
}
